module.exports = __webpack_public_path__ + "img/2s.f122359f.png";